import { useFormikContext } from "formik";
import AddressInputsBase from "./AddressInputsBase";
import { CardInfo } from "../CardInfo";
import React from "react";
import { WhmBox } from "@securitize/reactjs-whm";
import { translationKeys } from "../../../../contexts/I18nContext";
import { TranslateHtml } from "../../../../components/Translation/Translate";

type Props = {
  disabled?: boolean;
};

function AddressInputs({ disabled }: Props) {
  const formik = useFormikContext<{
    address1: string;
    address2: string;
    city: string;
    postalCode: string;
    country: string;
    region: string;
  }>();

  const errored =
    Boolean(formik.errors.address1) ||
    Boolean(formik.errors.address2) ||
    Boolean(formik.errors.city) ||
    Boolean(formik.errors.postalCode) ||
    Boolean(formik.errors.country) ||
    Boolean(formik.errors.region);

  // More specific disable logic:
  // - If country has data, keep it disabled
  // - If region has no data, enable only region field
  const shouldDisableCountry = disabled && Boolean(formik.values.country);
  const shouldDisableRegion = disabled && Boolean(formik.values.region);

  return (
    <>
      <AddressInputsBase
        disabled={disabled}
        disabledCountry={shouldDisableCountry}
        disabledRegion={shouldDisableRegion}
        errored={errored}
        addressInputName="address1"
        addressOptionalInputName="address2"
        cityInputName="city"
        stateInputName="region"
        postalCodeInputName="postalCode"
        countryInputName="country"
      />
      {disabled && (
        <WhmBox sx={{ mt: "24px" }}>
          <CardInfo
            text={
              <TranslateHtml
                translationKey={translationKeys.FORM_INFO_ADDRESS_FOOTER}
              />
            }
          />
        </WhmBox>
      )}
    </>
  );
}

export default AddressInputs;
